import { render, staticRenderFns } from "./ClassroomSheetEdit.vue?vue&type=template&id=095f4fe6&scoped=true&"
import script from "./ClassroomSheetEdit.vue?vue&type=script&lang=ts&"
export * from "./ClassroomSheetEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ClassroomSheetEdit.vue?vue&type=style&index=0&id=095f4fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f4fe6",
  null
  
)

export default component.exports